import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../../utils/api-client';

interface UseDisconnectDeviceReturn {
  disconnect: (deviceId: string) => Promise<void>;
  isDisconnecting: boolean;
  error: Error | null;
}

const disconnectUserDevice = async (deviceId: string): Promise<void> => {
  const response = await apiFetch(`/api/devices/${deviceId}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    throw new Error(`Failed to disconnect device: ${response.status}`);
  }
};

export const useDisconnectDevice = (): UseDisconnectDeviceReturn => {
  const queryClient = useQueryClient();

  const {
    mutateAsync: disconnect,
    isPending: isDisconnecting,
    error,
  } = useMutation({
    mutationFn: disconnectUserDevice,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['devices'] });
      queryClient.invalidateQueries({ queryKey: ['availableDevices'] });
    },
  });

  return {
    disconnect,
    isDisconnecting,
    error,
  };
};
